export default __webpack_public_path__ + "4187639a0b165c183014d2086313169f.png";